<template>

    <Modal
        ref="modal"
    >
        <template #title>
            <div class="flex justify-center">
                <img src="/img/logo.svg" class="h-20" alt="">
            </div>
        </template>

        <h3 class="text-2xl font-semibold mt-4 mb-2">Join our mailing list</h3>
        <p class="mb-4" v-text="marketingOptAgreedTerms"></p>

        <TextInput class="mb-4" v-model="email" />

        <div class="grid grid-cols-2 gap-4">
            <Button @click="submit(false)" type="secondary" size="large">Opt Out</Button>
            <Button @click="submit(true)" type="primary" size="large">Opt In</Button>
        </div>
    </Modal>

</template>


<script setup lang="ts">

import Modal from "@/components/core/modals/Modal.vue";
import TextInput from "@/components/forms/inputs/TextInput.vue";
import {useApiUser} from "@/composables/useApiUser";
import {useApi} from "@/composables/useApi";
import Button from "@/components/core/Button.vue";

const user = useApiUser();

const modal = ref<InstanceType<typeof Modal>|null>(null);
const email = ref<string>(user.value?.email ?? '');
const marketingOptAgreedTerms = "We would like to send you occasionally up-to-date information on Smith & Nephew product, services and educational events. You can unsubscribe at any time.";

async function submit(marketingOptIn: boolean) {
    const { fetch } = useApi({
        url: 'marketing-opt-ins',
        method: 'POST',
        payload: {
            email: email.value,
            marketing_opt_agreed_terms: marketingOptAgreedTerms,
            marketing_opt_in: false,
        }
    })

    await fetch();

    close();
}

function open() {
    modal.value?.open();
}

function close() {
    modal.value?.close();
}

defineExpose({open, close});

</script>